import React from "react";
import classNames from "classnames";

import styles from "./checkbox.module.scss";

type CheckboxProps = {
    id: string | number;
    className?: string;
    label?: string;
    isSelected?: boolean;
    onChange: (param: any) => void;
    onChangeParam: unknown;
    enabled?: boolean;
    testID?: string;
};

const Checkbox = ({
    className = "",
    id,
    label,
    isSelected = false,
    onChange = () => {},
    onChangeParam,
    enabled = true,
    testID,
}: CheckboxProps) => {
    const checkBoxId = `form_checkbox_${id}`;
    const checkBoxTestId = testID || `form_checkbox_${id}`;

    const handleChange = () => {
        if (!enabled) {
            return;
        }
        onChange(onChangeParam);
    };

    return (
        <label
            data-component="Checkbox"
            key={id}
            data-testid={checkBoxTestId}
            className={classNames(styles.me, {
                [className]: className,
                [styles.disabled]: !enabled,
            })}
            htmlFor={checkBoxId}
        >
            <input
                id={checkBoxId}
                name={checkBoxId}
                type="checkbox"
                checked={isSelected}
                onChange={handleChange}
            />
            <span className={styles.checkmark} />
            <span className={styles.checkboxLabel}>{label}</span>
        </label>
    );
};

export default Checkbox;
